<template>
  <v-container v-if="price > 0">
    <v-snackbar
      top
      color="error"
      v-model="snackbar"
      :timeout="6000"
      style="z-index: 9999"
    >
      {{ $t("payment.error") }}
      <v-btn dark text @click="snackbar = false">X</v-btn>
    </v-snackbar>
    <v-snackbar
      top
      color="success"
      v-model="snackbarSuccess"
      :timeout="6000"
      style="z-index: 9999"
    >
      {{
        $t(`payment.${pageType === "OEGG" ? "success" : "successExhibitor"}`)
      }}
      <v-btn dark text @click="snackbarSuccess = false">X</v-btn>
    </v-snackbar>
    <v-card class="mx-1 mb-12" :flat="pageType !== 'OEGG'">
      <v-card-title>{{ $t("payment.headline") }}</v-card-title>
      <v-card-text v-if="snackbarSuccess">
        {{
          $t(
            `payment.${pageType === "OEGG" ? "redirect" : "redirectExhibitor"}`
          )
        }}
      </v-card-text>
      <v-card-text v-else>
        <v-tabs v-model="tab">
          <v-tab>
            <v-icon class="mr-2">mdi-credit-card</v-icon>
            {{ $t("payment.creditcard") }}
          </v-tab>
          <v-tab>
            <v-icon class="mr-2">mdi-bank</v-icon>
            {{ $t("payment.sofort") }}
          </v-tab>

          <v-tab-item>
            <v-card flat class="mt-4">
              <v-form>
                <v-stripe-card
                  outlined
                  :api-key="apiKey"
                  :zip="
                    pageType === 'OEGG'
                      ? currentUser.attributes.zip
                      : currentExhibitor.companyPostalCode
                  "
                  ref="stripeCard"
                  v-model="token"
                  :label="$t('payment.creditcard')"
                ></v-stripe-card>
              </v-form>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat class="mt-4"> </v-card>
          </v-tab-item>
        </v-tabs>
      </v-card-text>
    </v-card>
    <v-layout v-if="!snackbarSuccess">
      <v-spacer></v-spacer>
      <v-btn text class="mr-4" @click="goBack">
        {{ $t("form.btn.back") }}
      </v-btn>
      <v-btn
        color="primary"
        class="mb-3"
        @click="submit"
        :disabled="paymentDialog || loading"
        :loading="loading"
      >
        {{ $t("form.btn.pay") }}
      </v-btn>
    </v-layout>
    <v-dialog v-model="paymentDialog" width="875" persistent>
      <v-card color="white">
        <iframe
          width="850"
          height="600"
          :src="iframeSrc"
          frameborder="0"
          sandbox="allow-forms allow-popups allow-pointer-lock allow-same-origin allow-scripts"
        ></iframe>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {
  payMembershipFeesResource,
  openPaymentsResource,
} from "../api/resources";
export default {
  created() {
    this.loadPrice();
  },

  props: ["selectedPersons", "selectedBills"],

  data() {
    return {
      stripe: null,
      stripElements: null,
      cardPayment: null,
      token: null,
      tab: null,
      snackbarSuccess: false,
      snackbar: null,
      paymentDialog: null,
      iframeSrc: null,
      payment: null,
      pendingPaymentAmount: 0,
      timer: null,
      loading: false,
      price: 0,
      openPayments: [],
    };
  },

  mounted() {
    const queryParams = new URLSearchParams(window.location.search);
    const paymentIntentClientSecret = queryParams.get(
      "payment_intent_client_secret"
    );

    if (paymentIntentClientSecret) {
      this.loading = true;
      this.checkStripeCard(paymentIntentClientSecret);
    }
  },

  methods: {
    ...mapActions(["authorize", "charge", "updateExhibitorPay"]),
    submit() {
      if (this.tab === 0) {
        this.submitCardPayment();
      } else if (this.tab === 1) {
        this.submitSofortPayment();
      }
    },

    async checkStripeCard(paymentIntentClientSecret) {
      if (this.$refs.stripeCard && this.$refs.stripeCard.stripe) {
        try {
          const stripe = this.$refs.stripeCard.stripe;
          const { paymentIntent } = await stripe.retrievePaymentIntent(
            paymentIntentClientSecret
          );
          if (paymentIntent.status === "succeeded") {
            const url = new URL(window.location.href);
            const token = url.searchParams.get("token"); // Get the 'token' parameter value
            url.search = ""; // Clear all search parameters
            if (token) {
              url.searchParams.set("token", token); // Set 'token' parameter if it was present
            }
            window.history.pushState({}, "", url.href);
            this.paymentSucceed();
          } else {
            console.log("PaymentIntent status: ", paymentIntent.status);
            this.snackbar = true;
          }
        } catch (err) {
          console.log("error ", err);
          this.snackbar = true;
        } finally {
          this.loading = false;
        }
      } else {
        setTimeout(() => this.checkStripeCard(paymentIntentClientSecret), 100); // Check again after 100ms
      }
    },

    async submitCardPayment() {
      this.loading = true;
      const paymentIntent = await this.authorize({ price: this.price });
      const stripe = this.$refs.stripeCard.stripe;
      try {
        const res = await stripe.confirmCardPayment(
          paymentIntent.result.client_secret,
          {
            payment_method: {
              card: this.$refs.stripeCard.card,
              billing_details: {
                name: this.billingName,
                email:
                  this.pageType === "OEGG"
                    ? this.currentUser.email
                    : this.currentExhibitor.email,
              },
            },
            save_payment_method: false,
          }
        );

        if (res.paymentIntent.status === "succeeded") {
          await this.paymentSucceed();
        }
      } catch (err) {
        this.snackbar = true;
      } finally {
        this.loading = false;
      }
    },

    async submitSofortPayment() {
      this.loading = true;
      const paymentIntent = await this.authorize({ price: this.price });
      const stripe = this.$refs.stripeCard.stripe;
      try {
        // remove all previous query parameters
        const url = new URL(window.location.href);
        const token = url.searchParams.get("token"); // Get the 'token' parameter value
        url.search = ""; // Clear all search parameters
        if (token) {
          url.searchParams.set("token", token); // Set 'token' parameter if it was present
        }
        window.history.pushState({}, "", url.href);
        await stripe.confirmKlarnaPayment(paymentIntent.result.client_secret, {
          payment_method: {
            billing_details: {
              name: this.billingName,
              email:
                this.pageType === "OEGG"
                  ? this.currentUser.email
                  : this.currentExhibitor.email,
              address: {
                country:
                  this.pageType === "OEGG"
                    ? this.currentUser.attributes.hasInvoiceAddress
                      ? this.currentUser.attributes.invoiceCountry
                      : this.currentUser.attributes.country
                    : this.currentExhibitor.companyCountry,
              },
            },
          },
          return_url: window.location.href,
          save_payment_method: false,
        });
      } catch (err) {
        this.snackbar = true;
      } finally {
        this.loading = false;
      }
    },

    async paymentSucceed() {
      this.snackbarSuccess = true;
      if (this.pageType === "OEGG") {
        await payMembershipFeesResource.post(
          "",
          {},
          {
            headers: {
              "x-xsrf-token": this.$cookies.get("oegg-cms.csrf"),
            },
          }
        );
      } else {
        await this.updateExhibitorPay({
          selectedBills: this.selectedBills,
          selectedPersons: this.selectedPersons,
        });
      }

      setTimeout(() => {
        this.goBack();
      }, 6000);
    },

    goBack() {
      this.$router.push(
        this.pageType === "OEGG" ? "/membership" : "/booth-information"
      );
    },

    async loadPrice() {
      if (this.pageType !== "OEGG") {
        if (!this.selectedBills || !this.selectedPersons) {
          this.goBack();
          return;
        }
        this.price =
          (this.currentExhibitor.bills || [])
            .filter((entry, index) => !entry.paid && this.selectedBills[index])
            .map((entry) => entry.amount)
            .reduce((entry1, entry2) => entry1 + entry2, 0) +
          (this.currentExhibitor.persons || []).filter(
            (entry, index) =>
              !entry.paid &&
              this.selectedPersons[index - this.currentExhibitor.amountPersons]
          ).length *
            (this.pageSettings.additionalPricePerPerson || 0);
        return;
      }
      this.openPayments = (await openPaymentsResource.get()).data;
      this.price = this.openPayments
        .filter((entry) => !entry.paid)
        .map((entry) => entry.fee)
        .reduce((entry1, entry2) => entry1 + entry2, 0);
    },
  },

  computed: {
    ...mapGetters([
      "currentUser",
      "currentExhibitor",
      "pageType",
      "pageSettings",
    ]),
    billingName() {
      if (this.pageType !== "OEGG") {
        return this.currentExhibitor.vendorName;
      }
      if (this.currentUser.attributes.hasInvoiceAddress) {
        return `${this.currentUser.attributes.invoiceFirstName} ${this.currentUser.attributes.invoiceLastName}`;
      }
      return `${this.currentUser.firstName} ${this.currentUser.lastName}`;
    },
    apiKey() {
      return (
        window.stripePublicKey ||
        process.env[`VUE_APP_STRIPE_PUBLIC_KEY_${this.pageType}`]
      );
    },
  },
};
</script>

<style></style>
